/**
 * Informations société — source unique de vérité
 * Modifiez ici pour propager sur tout le site.
 */
export const COMPANY = {
  name: 'Auth0.Expert',
  legalName: 'AUTH0 EXPERT SAS',
  siret: '000 000 000 00000',          // À remplacer
  siren: '000 000 000',                // À remplacer
  rcsCity: 'Paris',
  capitalSocial: '10 000 €',          // À remplacer
  tva: 'FR00000000000',               // À remplacer
  director: 'Zakaria B.',

  website: 'https://auth0.expert',

  email: 'contact@auth0.expert',
  emailHref: 'mailto:contact@auth0.expert',

  phone: '+33 1 23 45 67 89',
  phoneHref: 'tel:+33123456789',
  phoneDisplay: '+33 1 23 45 67 89',

  address: {
    street: '42 Rue de Rivoli',
    city: 'Paris',
    zip: '75001',
    country: 'France',
    full: '42 Rue de Rivoli, 75001 Paris, France',
  },
  mapsHref: 'https://www.google.com/maps/search/?api=1&query=42+Rue+de+Rivoli+75001+Paris+France',

  linkedin: 'https://linkedin.com/company/auth0-expert',
  github: 'https://github.com/bourharas',

  // Endpoint du chat IA — sera fourni ultérieurement
  chatApiEndpoint: process.env.REACT_APP_CHAT_API_URL || null,
};
